// Whether a document image can be rendered inline in the browser. A missing
// content type, PDFs, and images all render inline; everything else (e.g. CSV
// or XML royalty-check uploads) is download-only.
function isImageInlineRenderable(contentType?: string | null): boolean {
  return (
    !contentType ||
    contentType.startsWith('application/pdf') ||
    contentType.startsWith('image/')
  );
}

export { isImageInlineRenderable };
